import common from "./common";
import errors from "./errors";
import organizations from "./organizations";
import resellers from "./resellers";
import users from "./users";
import roles from "./roles";
import permissions from "./permissions";
import products from "./products";
import invoices from "./invoices";
import customers from "./customers";
import packages from "./packages";
import subscriptions from "./subscriptions";
import payments from "./payments";
import profile from "./profile";
import contacts from "@/i18n/en/contacts";
import suppliers from "@/i18n/en/suppliers";
import imports from "@/i18n/en/imports";
import veeValidateErrors from "./vee-validate-errors";
import provinces from "./provinces";
import fuelTypes from "./fuelTypes";
import drivetrain from "./drivetrain";
import odometers from "./odometers";
import vehicleClassCode from "./vehicleClassCode";
import requests from "./requests";
import estimateVehicles from "./estimate-vehicles";
import estimates from "./estimates";
import apps from "./apps";
import purchasesPayments from "./purchasesPayments";
import purchasesDeliveries from "./purchasesDeliveries";
import purchasesInvoices from "./purchasesInvoices";
import purchasesOrders from "./purchasesOrders";
import notifications from "./notifications";
import files from "./files";
import locations from "./locations";
import inspectionForms from "./inspection-forms";
import inspections from "./inspections";
import salesOrders from "./salesOrders";
import salesInvoices from "./salesInvoices";
import salesDeliveries from "./salesDeliveries";
import salesPayments from "./salesPayments";
import transmissions from "./transmissions";
import vehicles from "./vehicles";
import stockMovements from "./stockMovements";
import warehouses from "./warehouses";
import resellerPayments from "./resellerPayments";
import resellerInvoices from "./resellerInvoices";
import resellerServices from "./resellerServices";
import resellerProduct from "./resellerProduct";
import options from "./options";
import repairs from "./repairs";

export default {
  COMMON: common,
  APPS: apps,
  ERRORS: errors,
  USERS: users,
  ORGANIZATIONS: organizations,
  RESELLERS: resellers,
  ROLES: roles,
  PERMISSIONS: permissions,
  PRODUCTS: products,
  INVOICES: invoices,
  CUSTOMERS: customers,
  SUBSCRIPTIONS: subscriptions,
  PACKAGES: packages,
  PAYMENTS: payments,
  PROFILE: profile,
  REQUESTS: requests,
  INSPECTIONS: inspections,
  INSPECTION_FORMS: inspectionForms,
  CONTACTS: contacts,
  SUPPLIERS: suppliers,
  LOCATIONS: locations,
  FILES: files,
  NOTIFICATIONS: notifications,
  PURCHASES_ORDERS: purchasesOrders,
  PURCHASES_INVOICES: purchasesInvoices,
  PURCHASES_DELIVERIES: purchasesDeliveries,
  PURCHASES_PAYMENTS: purchasesPayments,
  SALES_ORDERS: salesOrders,
  SALES_INVOICES: salesInvoices,
  SALES_DELIVERIES: salesDeliveries,
  SALES_PAYMENTS: salesPayments,
  RESELLER_PRODUCTS: resellerProduct,
  RESELLER_SERVICES: resellerServices,
  RESELLER_INVOICES: resellerInvoices,
  RESELLER_PAYMENTS: resellerPayments,
  WAREHOUSES: warehouses,
  STOCK_MOVEMENTS: stockMovements,
  IMPORTS: imports,
  VEHICLES: vehicles,
  ESTIMATES: estimates,
  ESTIMATE_VEHICLES: estimateVehicles,
  PROVINCES: provinces,
  FUEL_TYPES: fuelTypes,
  TRANSMISSIONS: transmissions,
  DRIVETRAIN: drivetrain,
  ODOMETERS: odometers,
  VEHICLES_CLASSES: vehicleClassCode,
  OPTIONS: options,
  REPAIRS: repairs,
  validations: {
    ...veeValidateErrors,
  },
};
